module.exports = __webpack_public_path__ + "img/shin2.d620cae8.jpg";